import { put, call } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../../configs';
import makeRequest from '../../../../utils/makeRequest';
import { OK } from '../../../../configs/serverStatusCodes';
import { loadCurrentBlackWhitesByIdFailed, loadCurrentBlackWhitesByIdSuccessful } from '../../actions';
import { resolveActionPromise } from '../../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../../utils/rejectActionPromise';
import processError from '../../../../utils/processError';

export default function* loadCurrentBlackWhitesById(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadCurrentBlackWhitesByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadCurrentBlackWhitesByIdFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadCurrentBlackWhitesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
